import CIMSTable from 'components/CIMSTable'
import { useCASTypesContext } from '../../CASTypesContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreateOptions'
import { useEdit } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useRemove } from './hooks/useRemoveOptions'
import { useRestore } from './hooks/useRestore'

export const TypesTable: React.FC = () => {
  const { records, refetch: onReload, loading } = useCASTypesContext()

  return (
    <CIMSTable
      records={records}
      columns={useColumns()}
      loading={loading}
      rowKey={'id'}
      actions={{
        header: { create: useCreate(), onReload },
        row: { remove: useRemove(), edit: useEdit(), restore: useRestore() },
      }}
      expand={useExpandOptions()}
    />
  )
}
